var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoConference = function SvgVideoConference(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6v18h26V6Zm2 2h22v14H5Zm11 2c-1.645 0-3 1.355-3 3 0 .68.238 1.309.625 1.813C12.652 15.543 12 16.698 12 18h2c0-1.117.883-2 2-2s2 .883 2 2h2c0-1.3-.652-2.457-1.625-3.188A2.976 2.976 0 0 0 19 13c0-1.645-1.355-3-3-3Zm0 2c.563 0 1 .438 1 1 0 .563-.438 1-1 1-.563 0-1-.438-1-1 0-.563.438-1 1-1Zm-7 7v2h4v-2Zm5 0v2h4v-2Zm5 0v2h4v-2Zm-9 6v2h12v-2Z"
  })));
};
export default SvgVideoConference;